<template>
  <LmDialog v-model="modalShow" :styles="dialogStyles" title="Create link">
    <template #toolbar-actions>
      <q-btn :disable="created" size="sm" label="Save" color="tertiary" @click="process" />
    </template>
    <template #content>
      <q-card-section v-if="formData">
        <q-inner-loading :visible="loading">
          <q-spinner-audio :size="30" color="primary" />
        </q-inner-loading>
        <div class="row q-col-gutter-md q-mb-lg">
          <div class="col-xs-6">
            <enhanced-q-select v-model="formData.category_id" :options="categories" label="Category" />
          </div>
        </div>

        <div class="row q-col-gutter-md">
          <div class="col-xs-6">
            <q-input id="name" v-model="formData.name" stack-label label="Name" outlined type="text" />
          </div>

          <div class="col-xs-6">
            <q-input id="url" v-model.trim="formData.url" required stack-label label="URL" outlined />
          </div>

          <div class="col-xs-6">
            <q-input id="username" v-model.trim="formData.username" required stack-label label="Username" outlined />
          </div>

          <div class="col-xs-6">
            <q-input id="password" v-model.trim="formData.password" required stack-label label="Password" outlined />
          </div>

          <div class="col-xs-6">
            <q-input
              v-model.trim="formData.description"
              class="lm-textarea"
              rows="3"
              type="textarea"
              stack-label
              label="Description"
              outlined
            />
          </div>
        </div>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { cloneDeep, get } from 'lodash'
import { axiosInstance as request } from '@/api/rest.service'
// Components
import EnhancedQSelect from '@components/general/EnhancedQSelect'
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'FormCreateLink',
  inject: ['service'],
  components: { EnhancedQSelect, LmDialog },
  props: {
    showing: {
      type: Boolean,
      default: false
    },
    namespace: {
      type: String,
      required: true
    },
    editable: {
      type: [Object, null],
      default: null
    },
    selectedCategories: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      createData: null,
      formData: null,
      created: false,
      dialogStyles: { minWidth: '900px', minHeight: '400px' }
    }
  },
  computed: {
    dataTemplate() {
      return {
        name: null,
        url: null,
        username: null,
        password: null,
        description: null,
        category_id: this.selectedCategories.length === 1 ? this.selectedCategories[0] : 6
      }
    },
    modalShow: {
      get() {
        return this.showing
      },
      set(value) {
        !value && this.closeModal()
      }
    },
    categories() {
      if (!this.createData) return []
      return this.createData.categories.map(c => ({
        value: c.id,
        label: this.capitalizeSnakeCase(c.name),
        name: c.name
      }))
    }
  },
  watch: {
    editable(newVal) {
      let formData = newVal ? new LmFormObject(newVal) : new LmFormObject(this.dataTemplate)
      this.$set(this, 'formData', formData)
    },
    modalShow(val) {
      if (val && !this.editable) this.formData = new LmFormObject(this.dataTemplate)
    },
    categories(newVal) {
      this.$emit('categories-options', newVal)
    }
  },
  created() {
    this.getCreateData()
  },
  methods: {
    process() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      let params = {
        namespace: this.namespace,
        value: data
      }
      if (data.id) {
        params.id = data.id
      }
      let action = this.editable ? `update` : `create`
      this.loading = true
      this.service[action](params)
        .then(({ data }) => {
          if (!get(data, 'messages.errors')) {
            this.$emit('refresh', data.result)
            this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
            this.closeModal()
          } else {
            this.created = false
          }
        })
        .catch(() => {
          this.created = false
        })
        .finally(() => (this.loading = false))
    },
    closeModal() {
      this.$emit('close')
      this.created = false
      this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
    },
    getCreateData() {
      this.loading = true
      request({
        method: 'get',
        url: '/links/create'
      })
        .then(({ data }) => (this.createData = data.result))
        .finally(() => (this.loading = false))
    }
  }
}
</script>
